// @flow
import { PRIMARY_COLOR } from 'coooltv-js-shared/src/styles/common';
import React from 'react';
import {
    ActivityIndicator,
    Pressable, View,
} from 'react-native';
import Text from '../CustomText/CustomText';
import styles from './StyledButtonStyles';

type Props = {
    handleSubmit: Function,
    text: String,
    loading?: boolean,
};

const StyledButton = (props: Props) => {
    const { handleSubmit, text, loading } = props;
    return (
        <View style={styles.button_wrapper}>
            <Pressable
                onPress={handleSubmit}
                style={(state) => {
                    if (loading) {
                        return styles.button_off_hover;
                    }
                    if (state.hovered) {
                        return styles.button_on_hover;
                    }
                    return styles.button;
                }}
                disabled={loading}
            >
                {!loading ? (
                    (state) => (
                        <Text style={state.hovered ? styles.text_on_hover : styles.text}>
                            {text}
                        </Text>
                    )
                ) : (
                    <ActivityIndicator
                        size="large"
                        color={PRIMARY_COLOR}
                    />
                )}
            </Pressable>
        </View>
    );
};

StyledButton.defaultProps = {
    loading: false,
};

export default StyledButton;
